<div id="modal-LegalDisclaimer" class="c-modal-material">
  <button class="c-modal__close" (click)="close()"></button>
  <div class="c-modal__body" [innerHTML]="countryTranslationMap[countryId] | translate"></div>
</div>
